import {Outlet, useNavigate} from "react-router-dom";
import React from "react";
import {useAppSelector} from "@src/integrations/redux/redux-store";
import {selectIsLoggedIn} from "@src/features/auth/redux/auth-slice";


export function RequireIsNotLoggedInLayout() {
	const navigate = useNavigate();
	
	const isLoggedIn = useAppSelector(selectIsLoggedIn);
	
	React.useEffect(() => {
		if (isLoggedIn) {
			navigate("/dashboard");
		}
	}, [navigate, isLoggedIn]);
	
	if (isLoggedIn) {
		return (
			<p>
				Redirecting to dashboard...
			</p>
		);
	}
	
	return (
		<Outlet/>
	);
}
